import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import 'datatables.net-rowgroup-dt/css/rowGroup.dataTables.min.css'

import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import {Typeahead} from 'react-bootstrap-typeahead';
import {Table} from 'react-bootstrap';
import Help from '../../../generics/help';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

require( 'datatables.net-rowgroup-dt/js/rowGroup.dataTables.min');

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../../../config');

class PetitionStatistics extends Component {

    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.searching = this.searching.bind(this);
        this.isValidForm = this.isValidForm.bind(this);
        this.showCtrlError = this.showCtrlError.bind(this);
        this.setTable = this.setTable.bind(this);
        this.dateCompare = this.dateCompare.bind(this);
        this.excelStats = this.excelStats.bind(this);
        this.pdfStats = this.pdfStats.bind(this);

        this.state = {
            start_date: "",
            end_date: "",
			health_facilities_id: sessionStorage.getItem('health_facilities_id'),
            listado: [],
            columns: [
                { title: 'Tipo de Componente', width: '180px' },
                { title: 'Peticiones registradas', width: '100px' },
                { title: 'Componentes solicitados', width: '100px' },
                { title: 'Unidades Enviadas', width: '100px' },
                { title: 'Unidades Devueltas', width: '100px' }
            ],
            filename: "Estadística de Peticiones",
            isLanding: false,
            date_hour: "",
            totales: {
                peticiones_registradas: "0",
                componentes_solicitados: "0",
                unidades_enviadas: "0",
                unidades_devueltas: "0"
            }
        }
    }

    componentDidMount() {
        var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

        if (!this.props.hiddeToReport) {
            this.props.reload();
        }

        this.setState({
            health_facilities_id: sessionStorage.getItem('health_facilities_id') || "1"
        });

        setTimeout(() => {
            this.props.waiting.handleClose();
        }, 300);

        fetch(Config.default.apiGateway.URL + 'lookups?type=health_services&option=active&order=true', {
            method: 'GET',
            headers: new Headers({
                'Authorization': 'Bearer ' + sessionStorage.getItem('token'),
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            })
        })
            .then(res => res.ok ? res.json() : res.text().then(msg => swal("Error", msg, 'error')))
            .then(response => {
                if (response !== undefined) {
                    this.setState({ services: response });
                }
            });

        fetch(Config.default.apiGateway.URL + 'offers?option=date', {
            method: 'GET',
            headers: new Headers({
                'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            })
        })
            .then(res => res.json())
            .then(response => {
                if (!response) return;
                var aux = response.split('|');
                var hours = this.getHourFormat(aux[1]);
                var date = aux[0].split("/");

                this.setState({
                    date_hour: aux[0] + ' ' + hours,
                    start_date: date[2] + '-' + date[1] + '-' + date[0],
                    end_date: date[2] + '-' + date[1] + '-' + date[0],
                });
            });

        this.setTable()
    }

    getHourFormat(hr) {
        var format = hr.split(' ');
        var hrs = format[0].split(':');
        var ampm = format.length === 2 ? format[1] : format[1] + ' ' + format[2];
        var hour = parseInt(hrs[0], 10);
        var minute = parseInt(hrs[1], 10);

        if ((ampm === "PM" || ampm === "p. m.") && hour < 12) hour += 12;
        if ((ampm === "AM" || ampm === "a. m.") && hour === 12) hour -= 12;
        if (hour < 10) hour = '0' + hour;
        if (minute < 10) minute = '0' + minute;
        return hour + ':' + minute;
    }

    setTable() {
        var fechas = "Información Del: " + moment(this.state.start_date).format("DD/MM/YYYY") +
            " Al: " + moment(this.state.end_date).format("DD/MM/YYYY")
        this.$el = $(this.el);
        var table = this.$el.DataTable({
            dom: 'Bfrtip',
            buttons: [
                // {
                //     extend: 'excelHtml5',
                //     title: this.state.filename
                // },
                // {
                //     extend: 'pdf',
                //     title: this.state.filename,
                //     orientation: "landscape",
                //     customize: (doc) => {
                //         doc.content.unshift({
                //             image: this.props.header_document,
                //             alignment: 'center',
                //             width: this.props.w_head
                //         });

                //         doc.content.splice(2, 0, { text: fechas, margin: [10, 0, 0, 10] });

                //         doc.content[3].table.body.map((body, i) => {
                //             body.map((b, j) => {
                //                 if (j > 5 && j < body.length - 1) {
                //                     b.alignment = 'right';
                //                 }
                //             })
                //         })

                //         doc.content.push(
                //             {
                //                 text: 'Peticiones registradas: ' + this.state.totales.peticiones_registradas + '\t\t' +
                //                       'Componentes solicitados: ' + this.state.totales.componentes_solicitados + '\t\t' +
                //                       'Unidades Enviadas: ' + this.state.totales.unidades_enviadas + '\t\t' +
                //                       'Unidades Devueltas: ' + this.state.totales.unidades_devueltas + '\t\t',
                //                 margin: [0, 10, 0, 10]
                //             }
                //         )

                //         doc.styles.tableBodyOdd.fillColor = "#FFF";
                //         doc.defaultStyle.fontSize = 6.5;
                //         doc.styles.tableHeader.fontSize = 6.5;
                //         doc.footer = { text: this.state.date_hour + '\t-\t' + this.state.medical, alignment: 'right', margin: [0, 0, 50, 0] };
                //     }
                // }
            ],
            data: this.state.listado,
            columns: this.state.columns,
            oLanguage: {
                "sProcessing": "Procesando...",
                "sZeroRecords": "No se encontraron resultados",
                "sEmptyTable": "Ningún dato disponible en esta tabla",
                "sInfoPostFix": "",
                "sSearch": "Buscar:",
                "sUrl": "",
                "sInfoThousands": ",",
                "sLoadingRecords": "Cargando...",
                "fnInfoCallback": null,
            },
            paging: false,
            responsive: false,
            searching: false,
            scrollY: "32em",
            scrollX: true,
            autoWidth: false,
            ordering: false,
            info: false,
        });

        if (table.rows().indexes().length === 0) {
            table.buttons('.buttons-html5').disable();
        } else {
            table.buttons('.buttons-html5').enable();
        }
    }

    handleChange(e) {
        if (e.target) {
            this.setState({
                [e.target.name]: e.target.value
            });
            
            if(document.getElementById(e.target.name).className.includes('error')){
                document.getElementById(e.target.name).classList.remove('error');
            }

            if(e.target.name === 'work_session'){
                this.setState({
                    work_session_name: e.target.options[e.target.selectedIndex].text
                })
            }
        } else {
            if(e.length > 0){
                this.setState({
                    national_selected:e,
                    national_center_id:e[0].id
                });
            }
        }
    }

    searching(){
        if(this.isValidForm()){
            if(this.dateCompare()){
                this.props.waiting.handleShow('Buscando...');

                var obj = {
                    start_date: this.state.start_date,
                    end_date: this.state.end_date,
                    health_facilities_id:this.state.health_facilities_id,
                }
                
                fetch(Config.default.apiGateway.URL+'reports/petition_stats',{
                    method: 'POST',
                    body:JSON.stringify(obj),
                    headers: new Headers({
                        'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
                        'Accept'		: 'application/json',
                        'Content-Type'	: 'application/json'
                    })
                }).then(res => {
                    
                    if(res.ok){
                        return res.json();
                    }else{
                        this.props.waiting.handleClose();
                        res.text().then((msg)=>{
                            swal('Error', msg, 'error');
                        });
                    }
                }).then(response => {
                    if(response !== undefined){
                        this.setState({
                            listado: response.listado || [],
                            totales: response.totales || {
                                peticiones_registradas: "0",
                                componentes_solicitados: "0",
                                unidades_enviadas: "0",
                                unidades_devueltas: "0"
                            }
                        });

                        setTimeout(()=>{
                            this.props.waiting.handleShow('Cargando...');
                            this.$el = $(this.el);
                            this.$el.DataTable().destroy();
                            this.$el.empty();
                        }, 500);

                        setTimeout(()=>{
                            this.props.waiting.handleClose();
                            try {
                                this.setTable();
                            } catch (error) {
                                console.error('Error setting table:', error);
                            }
                        }, 1000);
                    }
                });
            }else{
                swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
            }
            
        }else{
            swal('Error', 'Campos Incompletos', 'error');
        }
    }

    dateCompare() {
        var ini = moment(this.state.start_date);
        var fin = moment(this.state.end_date);
        var date_ok = true;
        if (this.state.search_type === 'date') {
            if (ini !== 'Invalid date' && fin !== 'Invalid date') {
                if (fin < ini) {
                    date_ok = false;
                    document.getElementById('end_date').classList.add('error');
                } else {
                    document.getElementById('end_date').classList.remove('error');
                }
            } else {
                date_ok = false;
            }
        }

        return date_ok;
    }

    isValidForm() {
        const select = document.querySelector('form');
        const inputs = select.querySelectorAll('input, select');
        let isFormValid = true;
        
        inputs.forEach(input => {
            if(input.required){
                
                const isInputValid = this.showCtrlError(input.name);
                if (!isInputValid) {
                    isFormValid = false;
                }
                
            }
        });	    

        return isFormValid;
    }

    showCtrlError(refName) {
        var res = null;
        var control = document.getElementById(refName);
        if (this.state[refName] === "") {

            if(control !== null){
                control.classList.add('error');
            }
            res = false;
        } else{
            if(control !== null){
                if(control.required && control.className.includes('error')){
                    control.classList.remove('error');
                }
            }
            res = true;
        }
        

        return res;
    }

    excelStats() {
        var obj = {
            start_date: this.state.start_date,
            end_date: this.state.end_date,
            health_facilities_id: this.state.health_facilities_id
        };

        this.props.waiting.handleShow('Generando Excel...');
        fetch(Config.default.apiGateway.URL + 'reports/generate_excel?report_name=petition_stats', {
            method: 'POST',
            body: JSON.stringify(obj),
            responseType: 'blob',
            headers: new Headers({
                'Authorization': 'Bearer ' + sessionStorage.getItem('token'),
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            })
        }).then(res => {
            this.props.waiting.handleClose();
            if (res.ok) {
                return res.blob();
            } else {
                res.text().then(msg => {
                    swal('Error', msg, 'error');
                });
            }
        }).then(response => {
            if (response !== undefined) {
                var blob = new Blob([response], { type: 'application/vnd.ms-excel' });
                var downloadUrl = URL.createObjectURL(blob);
                var a = document.createElement("a");
                a.href = downloadUrl;
                a.download = this.state.filename + '.xlsx';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(downloadUrl);
            }
        });
    }

    pdfStats() {
        var fechas = "Información Del: " + (this.state.start_date !== "" ? moment(this.state.start_date).format("DD/MM/YYYY") : '') +
            " Al: " + (this.state.end_date !== "" ? moment(this.state.end_date).format("DD/MM/YYYY") : '')

        var doc = {
            content: [
                {
                    image: this.props.header_document,
                    alignment: 'center',
                    width: this.props.w_head
                },
                {
                    text: this.state.filename, style: 'title', margin: [0, 10, 0, 12], alignment: 'center', fontSize: 15
                },
                {
                    text: fechas, margin: [10, 0, 0, 10]
                },
                {
                    layout: 'noBorders',
                    table: {
                        body: [],
                        headerRows: 1,
                        widths: ['40%', '15%', '15%', '15%', '15%']
                    }
                }
            ],
            defaultStyle: { fontSize: 8 },
            pageMargins: 40,
            footer: { text: this.state.date_hour + '\t-\t' + this.state.medical, alignment: 'right', margin: [0, 0, 50, 0] },
            pageOrientation: 'portrait',
            pageSize: 'A4',
            styles: {
                tableBodyEven: {},
                tableBodyOdd: { fillColor: '#f3f3f3' },
                tableHeader: { bold: true, fontSize: 8, color: 'white', fillColor: '#2d4154', alignment: 'center' }
            }
        };

        var body = [];
        var headerRow = [];
        this.state.columns.forEach((col) => {
            headerRow.push({ text: col.title, style: 'tableHeader', fillColor: '#2d4154' });
        });
        body.push(headerRow);

        this.state.listado.forEach((row, i) => {
            var dataRow = [];
            Object.values(row).forEach((value) => {
                dataRow.push({ text: value, style: ((i + 1) % 2) === 0 ? 'tableBodyOdd' : 'tableBodyEven' });
            });
            body.push(dataRow);
        });

        doc.content[3].table.body = body;

        doc.content.push(
            {
                text: 'Peticiones registradas: ' + this.state.totales.peticiones_registradas + '\t\t' +
                      'Componentes solicitados: ' + this.state.totales.componentes_solicitados + '\t\t' +
                      'Unidades Enviadas: ' + this.state.totales.unidades_enviadas + '\t\t' +
                      'Unidades Devueltas: ' + this.state.totales.unidades_devueltas + '\t\t',
                margin: [0, 10, 0, 10]
            }
        );

        pdfMake.createPdf(doc).download(this.state.filename + '.pdf');
    }

    render(){
        const {t} = this.props;

        return (
            <div className="col-xs-12">
                <div className="route">
                    <h5 className="title_page">
                        {session} {'>'}
                        {t('sidebar.nav.reports.MAIN')} {'>'}
                        Pacientes {'>'}
                        {this.state.filename}
                    </h5>
                </div>
                <Help 
                    {...this.props}
                    menu={"help_patients"} 
                    submenu={"help_petitions_registered"}  />
                <div className="form-group" style={{paddingLeft:"0.5em"}}>
                    <div className="col-xs-12">
                        <form noValidate>
                            <div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>
                                
                                <div className="form-group">
                                    <span className="span-min">Fecha Desde</span>
                                    <input type="date" className="form-control hour-input" name="start_date" id="start_date"
                                        value={this.state.start_date} onChange={this.handleChange} required  />
                                </div>
                                <div className="form-group">
                                    <span className="span-min">Fecha Hasta</span>
                                    <input type="date" className="form-control hour-input" name="end_date" id="end_date"
                                        value={this.state.end_date} onChange={this.handleChange} required />
                                </div>
                                                            
                                <div style={{textAlign:"right"}}>
                                    <button type="button" className="btn btn-info" onClick={this.searching} style={{fontSize:"1em"}}>
                                        Buscar
                                    </button>
                                </div>
                            </div>

                            <div className="col-xs-12 col-sm-10">
                                <div className="col-xs-12">
                                    <div className="col-xs-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline"}}>
                                        <span>
                                            {this.state.filename}
                                        </span>
                                    </div>
                                </div>
                                
                                <div className="col-xs-12" >
                                    <span>
                                        Información Del:   {this.state.start_date !== "" ? 
                                            moment(this.state.start_date).format('DD/MM/YYYY')
                                        :'  '}
                                    </span>
                                    <span style={{marginLeft:"5px"}}>	
                                        Al: {this.state.end_date !== "" ? 
                                            moment(this.state.end_date).format('DD/MM/YYYY')
                                        :'  '}
                                    </span>
                                </div>

                                {this.state.listado.length > 0 &&
                                    <div className="dt-buttons" style={{float:'right'}}> 
                                        <button className="dt-button buttons-excel buttons-html5" tabIndex="0" aria-controls="table-to-xls" type="button" onClick={()=>this.excelStats()}>
                                            <span>Excel</span>
                                        </button> 
                                        <button className="dt-button buttons-pdf buttons-html5" tabIndex="0" aria-controls="table-to-xls" type="button" onClick={()=>this.pdfStats()}>
                                            <span>PDF</span>
                                        </button> 
                                    </div>
                                }

                                <div className="col-xs-12 form-group" id="table-to-pdf">									
                                    <div className="table-responsive">
                                        <table style={{fontSize:"11px"}} className={"expenses-discards"} id="table-to-xls" 
                                            ref={el => this.el = el}>
                                        </table>
                                    </div>

                                </div>
                                <div className="col-xs-12" >									
                                    <span style={{marginLeft:'10px'}}>Peticiones registradas: </span><label>{' '+this.state.totales.peticiones_registradas}</label>
                                    <span style={{marginLeft:'10px'}}>Componentes solicitados: </span><label>{' '+this.state.totales.componentes_solicitados}</label>
                                    <span style={{marginLeft:'10px'}}>Unidades Enviadas: </span><label>{' '+this.state.totales.unidades_enviadas}</label>
                                    <span style={{marginLeft:'10px'}}>Unidades Devueltas: </span><label>{' '+this.state.totales.unidades_devueltas}</label>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}

export default translate('translations')(PetitionStatistics);